import { render } from "./BannerFinal.vue?vue&type=template&id=4caed2e2&scoped=true&ts=true"
import script from "./BannerFinal.ts?vue&type=script&lang=ts&external"
export * from "./BannerFinal.ts?vue&type=script&lang=ts&external"

import "../Banner.scss?vue&type=style&index=0&id=4caed2e2&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4caed2e2"]])

export default __exports__